<template>
 <div class="carrusel-container-personajes">
  <div class="container-graph">
    <h3>Top 10 de embarcaciones que más pescaron en reservas nacionales</h3>
<svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1050.47 611.01">
  <defs>
    <clipPath id="clippath">
      <circle class="cls-1" cx="72.21" cy="508.99" r="40"/>
    </clipPath>
    <clipPath id="clippath-1">
      <circle class="cls-1" cx="173.86" cy="508.99" r="40"/>
    </clipPath>
    <clipPath id="clippath-2">
      <circle class="cls-1" cx="273.59" cy="508.99" r="40"/>
    </clipPath>
    <clipPath id="clippath-3">
      <circle class="cls-1" cx="373.96" cy="508.99" r="40"/>
    </clipPath>
    <clipPath id="clippath-4">
      <circle class="cls-1" cx="480.75" cy="508.99" r="40"/>
    </clipPath>
    <clipPath id="clippath-5">
      <circle class="cls-1" cx="584.46" cy="508.99" r="40"/>
    </clipPath>
    <clipPath id="clippath-6">
      <circle class="cls-1" cx="694.52" cy="508.99" r="40"/>
    </clipPath>
    <clipPath id="clippath-7">
      <circle class="cls-1" cx="807.04" cy="508.99" r="40"/>
    </clipPath>
    <clipPath id="clippath-8">
      <circle class="cls-1" cx="904.72" cy="508.99" r="40"/>
    </clipPath>
    <clipPath id="clippath-9">
      <circle class="cls-1" cx="1003.4" cy="508.99" r="40"/>
    </clipPath>
    <image id="image" width="400" height="400" xlink:href="/wp-content/interactivos/especial-pesca/fotos/tasa59.jpg"/>
    <image id="image-2" width="600" height="517" xlink:href="/wp-content/interactivos/especial-pesca/fotos/tasa51.jpg"/>
  </defs>
  <g id="Layer_1-2" data-name="Layer 1">
    <rect id="undefined_-_total" data-name="undefined - total" class="cls-15" x="36.78" y="59.46" width="26.18" height="387.37"/>
    <rect id="undefined_-_paracas" data-name="undefined - paracas" class="cls-28" x="64.13" y="245.03" width="26.18" height="201.79"/>
    <rect id="undefined_-_dorsal_de_nasca" data-name="undefined - dorsal_de_nasca" class="cls-7" x="91.48" y="261.25" width="26.18" height="185.58"/>
    <rect id="undefined_-_total-2" data-name="undefined - total" class="cls-15" x="135.83" y="119.81" width="26.18" height="327.01"/>
    <rect id="undefined_-_paracas-2" data-name="undefined - paracas" class="cls-28" x="163.18" y="268.45" width="26.18" height="178.37"/>
    <rect id="undefined_-_dorsal_de_nasca-2" data-name="undefined - dorsal_de_nasca" class="cls-7" x="190.53" y="298.18" width="26.18" height="148.64"/>
    <rect id="undefined_-_total-3" data-name="undefined - total" class="cls-15" x="234.29" y="136.93" width="26.18" height="309.89"/>
    <rect id="undefined_-_paracas-3" data-name="undefined - paracas" class="cls-28" x="261.64" y="263.95" width="26.18" height="182.87"/>
    <rect id="undefined_-_dorsal_de_nasca-3" data-name="undefined - dorsal_de_nasca" class="cls-7" x="288.99" y="319.8" width="26.18" height="127.02"/>
    <rect id="undefined_-_total-4" data-name="undefined - total" class="cls-15" x="334.1" y="138.73" width="26.18" height="308.09"/>
    <rect id="undefined_-_paracas-4" data-name="undefined - paracas" class="cls-28" x="361.45" y="359.44" width="26.18" height="87.38"/>
    <rect id="undefined_-_dorsal_de_nasca-4" data-name="undefined - dorsal_de_nasca" class="cls-7" x="388.8" y="226.11" width="26.18" height="220.71"/>
    <rect id="undefined_-_total-5" data-name="undefined - total" class="cls-15" x="440.86" y="158.55" width="26.18" height="288.27"/>
    <rect id="undefined_-_paracas-5" data-name="undefined - paracas" class="cls-28" x="468.2" y="281.97" width="26.18" height="164.86"/>
    <rect id="undefined_-_dorsal_de_nasca-5" data-name="undefined - dorsal_de_nasca" class="cls-7" x="495.55" y="323.41" width="26.18" height="123.42"/>
    <rect id="undefined_-_total-6" data-name="undefined - total" class="cls-15" x="544.16" y="163.96" width="26.18" height="282.87"/>
    <rect id="undefined_-_paracas-6" data-name="undefined - paracas" class="cls-28" x="571.51" y="350.43" width="26.18" height="96.39"/>
    <rect id="undefined_-_dorsal_de_nasca-6" data-name="undefined - dorsal_de_nasca" class="cls-7" x="598.86" y="260.35" width="26.18" height="186.48"/>
    <rect id="undefined_-_total-7" data-name="undefined - total" class="cls-15" x="654.46" y="164.86" width="26.18" height="281.97"/>
    <rect id="undefined_-_paracas-7" data-name="undefined - paracas" class="cls-28" x="681.8" y="363.94" width="26.18" height="82.88"/>
    <rect id="undefined_-_dorsal_de_nasca-7" data-name="undefined - dorsal_de_nasca" class="cls-7" x="709.15" y="247.73" width="26.18" height="199.09"/>
    <rect id="undefined_-_total-8" data-name="undefined - total" class="cls-15" x="766.84" y="184.67" width="26.18" height="262.15"/>
    <rect id="undefined_-_paracas-8" data-name="undefined - paracas" class="cls-28" x="794.19" y="184.67" width="26.18" height="262.15"/>
    <rect id="undefined_-_total-9" data-name="undefined - total" class="cls-15" x="865.27" y="184.67" width="26.18" height="262.15"/>
    <rect id="undefined_-_paracas-9" data-name="undefined - paracas" class="cls-28" x="892.62" y="184.67" width="26.18" height="262.15"/>
    <rect id="undefined_-_total-10" data-name="undefined - total" class="cls-15" x="963.71" y="186.93" width="26.18" height="259.9"/>
    <rect id="undefined_-_paracas-10" data-name="undefined - paracas" class="cls-28" x="991.05" y="407.18" width="26.18" height="39.64"/>
    <rect id="undefined_-_dorsal_de_nasca-8" data-name="undefined - dorsal_de_nasca" class="cls-7" x="1018.4" y="226.11" width="26.18" height="220.71"/>
    <g>
      <line class="cls-5" x1="30.89" y1="455.32" x2="31.89" y2="455.32"/>
      <line class="cls-2" x1="33.89" y1="455.32" x2="40.89" y2="455.32"/>
      <line class="cls-3" x1="41.89" y1="455.32" x2="1048.47" y2="455.32"/>
      <line class="cls-5" x1="1049.47" y1="455.32" x2="1050.47" y2="455.32"/>
    </g>
    <line class="cls-4" x1="77.22" y1="456.71" x2="77.22" y2="461.05"/>
    <text class="cls-13" transform="translate(42.84 573.87)"><tspan class="cls-30" x="0" y="0">T</tspan><tspan x="8.4" y="0">ASA 71</tspan></text>
    <text class="cls-12" transform="translate(31.24 596.3)"><tspan x="0" y="0">TECNO</tspan><tspan class="cls-34" x="32.32" y="0">L</tspan><tspan x="37.42" y="0">ÓGICA DE</tspan><tspan x="5.55" y="12">ALIME</tspan><tspan class="cls-33" x="35" y="12">NT</tspan><tspan x="47.97" y="12">OS SA</tspan></text>
    <text class="cls-12" transform="translate(154.53 596.3)"><tspan class="cls-39" x="0" y="0">A</tspan><tspan x="6.65" y="0">USTRA</tspan><tspan x="1.53" y="12" xml:space="preserve"> GROUP</tspan></text>
    <text class="cls-12" transform="translate(248.37 596.3)"><tspan x="0" y="0">PESQUERA</tspan><tspan x="2.18" y="12">EXAL</tspan><tspan class="cls-42" x="26.3" y="12">M</tspan><tspan x="35.15" y="12">AR</tspan></text>
    <text class="cls-12" transform="translate(348.73 596.3)"><tspan x="0" y="0">PESQUERA</tspan><tspan x="2.18" y="12">EXAL</tspan><tspan class="cls-42" x="26.3" y="12">M</tspan><tspan x="35.15" y="12">AR</tspan></text>
    <text class="cls-12" transform="translate(439.79 596.3)"><tspan x="0" y="0">TECNO</tspan><tspan class="cls-34" x="32.32" y="0">L</tspan><tspan x="37.42" y="0">ÓGICA DE</tspan><tspan x="5.55" y="12">ALIME</tspan><tspan class="cls-33" x="35" y="12">NT</tspan><tspan x="47.97" y="12">OS SA</tspan></text>
    <text class="cls-12" transform="translate(766.07 596.3)"><tspan x="0" y="0">TECNO</tspan><tspan class="cls-34" x="32.32" y="0">L</tspan><tspan x="37.42" y="0">ÓGICA DE</tspan><tspan x="5.55" y="12">ALIME</tspan><tspan class="cls-33" x="35" y="12">NT</tspan><tspan x="47.97" y="12">OS SA</tspan></text>
    <text class="cls-12" transform="translate(863.75 596.3)"><tspan x="0" y="0">TECNO</tspan><tspan class="cls-34" x="32.32" y="0">L</tspan><tspan x="37.42" y="0">ÓGICA DE</tspan><tspan x="5.55" y="12">ALIME</tspan><tspan class="cls-33" x="35" y="12">NT</tspan><tspan x="47.97" y="12">OS SA</tspan></text>
    <text class="cls-12" transform="translate(962.43 596.3)"><tspan x="0" y="0">TECNO</tspan><tspan class="cls-34" x="32.32" y="0">L</tspan><tspan x="37.42" y="0">ÓGICA DE</tspan><tspan x="5.55" y="12">ALIME</tspan><tspan class="cls-33" x="35" y="12">NT</tspan><tspan x="47.97" y="12">OS SA</tspan></text>
    <text class="cls-12" transform="translate(559.24 596.3)"><tspan x="0" y="0">PESQUERA</tspan><tspan x="2.18" y="12">EXAL</tspan><tspan class="cls-42" x="26.3" y="12">M</tspan><tspan x="35.15" y="12">AR</tspan></text>
    <text class="cls-12" transform="translate(669.3 596.3)"><tspan x="0" y="0">PESQUERA</tspan><tspan x="2.18" y="12">EXAL</tspan><tspan class="cls-42" x="26.3" y="12">M</tspan><tspan x="35.15" y="12">AR</tspan></text>
    <text class="cls-14" transform="translate(40.25 52.05)"><tspan x="0" y="0">4.300 </tspan></text>
    <line class="cls-4" x1="176.27" y1="456.71" x2="176.27" y2="461.05"/>
    <text class="cls-13" transform="translate(143.19 573.87)"><tspan x="0" y="0">DON OLE</tspan></text>
    <line class="cls-4" x1="274.89" y1="456.71" x2="274.89" y2="461.05"/>
    <text class="cls-13" transform="translate(226.53 573.87)"><tspan x="0" y="0">CARMENC</tspan><tspan class="cls-33" x="71.46" y="0">I</tspan><tspan class="cls-30" x="75.62" y="0">T</tspan><tspan x="84.02" y="0">A</tspan></text>
    <line class="cls-4" x1="374.54" y1="456.71" x2="374.54" y2="461.05"/>
    <text class="cls-13" transform="translate(349.54 573.87)"><tspan x="0" y="0">RO</tspan><tspan class="cls-37" x="19.93" y="0">D</tspan><tspan x="29.52" y="0">AS</tspan></text>
    <line class="cls-4" x1="481.29" y1="456.71" x2="481.29" y2="461.05"/>
    <text class="cls-13" transform="translate(451.38 573.87)"><tspan class="cls-30" x="0" y="0">T</tspan><tspan x="8.4" y="0">ASA 59</tspan></text>
    <line class="cls-4" x1="584.6" y1="456.71" x2="584.6" y2="461.05"/>
    <text class="cls-13" transform="translate(561.23 573.87)"><tspan x="0" y="0">CR</tspan><tspan class="cls-44" x="19.39" y="0">E</tspan><tspan class="cls-30" x="27.97" y="0">T</tspan><tspan x="36.37" y="0">A</tspan></text>
    <line class="cls-4" x1="694.89" y1="456.71" x2="694.89" y2="461.05"/>
    <text class="cls-13" transform="translate(645.03 573.87)"><tspan x="0" y="0">DON ALFREDO</tspan></text>
    <line class="cls-4" x1="807.28" y1="456.71" x2="807.28" y2="461.05"/>
    <text class="cls-13" transform="translate(773.36 573.87)"><tspan class="cls-30" x="0" y="0">T</tspan><tspan class="cls-27" x="8.4" y="0">ASA 416</tspan></text>
    <line class="cls-4" x1="905.71" y1="456.71" x2="905.71" y2="461.05"/>
    <text class="cls-13" transform="translate(871.04 573.87)"><tspan class="cls-30" x="0" y="0">T</tspan><tspan class="cls-16" x="8.4" y="0">ASA 418</tspan></text>
    <line class="cls-4" x1="1004.14" y1="456.71" x2="1004.14" y2="461.05"/>
    <text class="cls-13" transform="translate(974.03 573.87)"><tspan class="cls-30" x="0" y="0">T</tspan><tspan class="cls-16" x="8.4" y="0">ASA 51</tspan></text>
    <path class="cls-6" d="M30.89,441.67V36.29"/>
    <line class="cls-4" x1="30.89" y1="441.67" x2="23.77" y2="441.67"/>
    <text class="cls-11" transform="translate(15.75 443.99) scale(1.12 1)"><tspan x="0" y="0">0</tspan></text>
    <line class="cls-4" x1="30.89" y1="396.63" x2="23.77" y2="396.63"/>
    <text class="cls-11" transform="translate(6.75 398.94) scale(1.12 1)"><tspan x="0" y="0">500</tspan></text>
    <line class="cls-4" x1="30.89" y1="351.59" x2="23.77" y2="351.59"/>
    <text class="cls-11" transform="translate(0 353.9) scale(1.12 1)"><tspan x="0" y="0">1</tspan><tspan class="cls-31" x="3.26" y="0">,</tspan><tspan x="4.9" y="0">000</tspan></text>
    <line class="cls-4" x1="30.89" y1="306.54" x2="23.77" y2="306.54"/>
    <text class="cls-11" transform="translate(0 308.86) scale(1.12 1)"><tspan x="0" y="0">1</tspan><tspan class="cls-43" x="3.26" y="0">,</tspan><tspan x="5.07" y="0">500</tspan></text>
    <line class="cls-4" x1="30.89" y1="261.5" x2="23.77" y2="261.5"/>
    <text class="cls-11" transform="translate(0 263.82) scale(1.12 1)"><tspan x="0" y="0">2</tspan><tspan class="cls-31" x="3.67" y="0">,</tspan><tspan x="5.31" y="0">000</tspan></text>
    <line class="cls-4" x1="30.89" y1="216.46" x2="23.77" y2="216.46"/>
    <text class="cls-11" transform="translate(0 218.77) scale(1.12 1)"><tspan x="0" y="0">2</tspan><tspan class="cls-41" x="3.67" y="0">,</tspan><tspan class="cls-26" x="5.48" y="0">500</tspan></text>
    <line class="cls-4" x1="30.89" y1="171.41" x2="23.77" y2="171.41"/>
    <text class="cls-11" transform="translate(0 173.73) scale(1.12 1)"><tspan x="0" y="0">3</tspan><tspan class="cls-31" x="3.69" y="0">,</tspan><tspan x="5.34" y="0">000</tspan></text>
    <line class="cls-4" x1="30.89" y1="126.37" x2="23.77" y2="126.37"/>
    <text class="cls-11" transform="translate(0 128.69) scale(1.12 1)"><tspan x="0" y="0">3</tspan><tspan class="cls-41" x="3.69" y="0">,</tspan><tspan class="cls-26" x="5.5" y="0">500</tspan></text>
    <line class="cls-4" x1="30.89" y1="81.33" x2="23.77" y2="81.33"/>
    <text class="cls-11" transform="translate(0 83.65) scale(1.12 1)"><tspan x="0" y="0">4</tspan><tspan class="cls-31" x="3.98" y="0">,</tspan><tspan x="5.62" y="0">000</tspan></text>
    <line class="cls-4" x1="30.89" y1="36.29" x2="23.77" y2="36.29"/>
    <text class="cls-11" transform="translate(0 38.6) scale(1.12 1)"><tspan x="0" y="0">4</tspan><tspan class="cls-43" x="3.98" y="0">,</tspan><tspan x="5.79" y="0">500</tspan></text>
    <g class="cls-40">
      <use transform="translate(26.94 468.11) scale(.16)" xlink:href="#image-2"/>
    </g>
    <g class="cls-17">
      <image width="1600" height="1200" transform="translate(240.91 465.71) rotate(-180) scale(.08 -.08)" xlink:href="/wp-content/interactivos/especial-pesca/fotos/don_ole.png"/>
    </g>
    <g class="cls-20">
      <image width="1600" height="1157" transform="translate(214.05 467.68) scale(.08)" xlink:href="/wp-content/interactivos/especial-pesca/fotos/carmencita.png"/>
    </g>
    <g class="cls-18">
      <image width="1600" height="1200" transform="translate(313.58 463.96) scale(.08)" xlink:href="/wp-content/interactivos/especial-pesca/fotos/rodas.png"/>
    </g>
    <g class="cls-19">
      <use transform="translate(418.15 462.65) scale(.31)" xlink:href="#image"/>
    </g>
    <g class="cls-25">
      <image width="1600" height="1200" transform="translate(496.03 454.07) scale(.09)" xlink:href="/wp-content/interactivos/especial-pesca/fotos/creta.png"/>
    </g>
    <g class="cls-22">
      <image id="imagedon" width="800" height="599" transform="translate(630.18 460.99) scale(.15)" xlink:href="/wp-content/interactivos/especial-pesca/fotos/don_alfredo.png"/>
    </g>
    <g class="cls-21">
      <image width="1280" height="960" transform="translate(666.39 464.32) scale(.17)" xlink:href="/wp-content/interactivos/especial-pesca/fotos/tasa416.jpg"/>
    </g>
    <g class="cls-24">
      <use transform="translate(842.11 462.65) scale(.31)" xlink:href="#image"/>
      <image width="1568" height="1176" transform="translate(849.58 415.53) scale(.12)" xlink:href="/wp-content/interactivos/especial-pesca/fotos/tasa418.png"/>
    </g>
    <g class="cls-23">
      <use transform="translate(940.8 462.65) scale(.31)" xlink:href="#image"/>
      <use transform="translate(943.47 462.9) scale(.22)" xlink:href="#image-2"/>
    </g>
    <text class="cls-8" transform="translate(40.56 11.12)"><tspan class="cls-29" x="0" y="0">T</tspan><tspan x="6.57" y="0">otal de</tspan><tspan class="cls-32" x="0" y="15.6">t</tspan><tspan x="4.13" y="15.6">oneladas de pesca </tspan></text>
    <text class="cls-9" transform="translate(646.22 28.3)"><tspan class="cls-29" x="0" y="0">T</tspan><tspan x="7.08" y="0">oneladas de pesca por </tspan><tspan class="cls-36" x="151.85" y="0">r</tspan><tspan x="156.65" y="0">ese</tspan><tspan class="cls-42" x="178.9" y="0">r</tspan><tspan class="cls-38" x="183.94" y="0">v</tspan><tspan x="190.76" y="0">a</tspan></text>
    <text class="cls-14" transform="translate(137.6 110.04)"><tspan x="0" y="0">3.630</tspan></text>
    <text class="cls-14" transform="translate(237.22 128.86)"><tspan x="0" y="0">3.440</tspan></text>
    <text class="cls-14" transform="translate(337.3 130.18)"><tspan x="0" y="0">3.420</tspan></text>
    <text class="cls-14" transform="translate(440.02 151.42)"><tspan x="0" y="0">3.200</tspan></text>
    <text class="cls-14" transform="translate(544.79 157.23)"><tspan x="0" y="0">3.140</tspan></text>
    <text class="cls-14" transform="translate(653.75 159.53)"><tspan x="0" y="0">3.130</tspan></text>
    <text class="cls-14" transform="translate(767.5 179.42)"><tspan x="0" y="0">2.910</tspan></text>
    <text class="cls-14" transform="translate(866.14 180.57)"><tspan x="0" y="0">2.910</tspan></text>
    <text class="cls-14" transform="translate(962.47 183.26)"><tspan x="0" y="0">2.885</tspan></text>
    <g>
      <text class="cls-10" transform="translate(755.98 63.52)"><tspan x="0" y="0">Rese</tspan><tspan class="cls-42" x="33.2" y="0">r</tspan><tspan class="cls-38" x="38.61" y="0">v</tspan><tspan x="45.92" y="0">a de </tspan><tspan class="cls-35" x="78.02" y="0">P</tspan><tspan x="87.52" y="0">a</tspan><tspan class="cls-32" x="95.64" y="0">r</tspan><tspan x="100.69" y="0">acas</tspan></text>
      <rect id="undefined_-_paracas-11" data-name="undefined - paracas" class="cls-28" x="724.77" y="45.76" width="25" height="25"/>
    </g>
    <g>
      <text class="cls-10" transform="translate(935.41 63.52)"><tspan x="0" y="0">Dorsal de Nasca</tspan></text>
      <rect id="undefined_-_dorsal_de_nasca-9" data-name="undefined - dorsal_de_nasca" class="cls-7" x="905.03" y="45.76" width="25" height="25"/>
    </g>
    <g>
      <rect id="undefined_-_total-11" data-name="undefined - total" class="cls-15" x="650.1" y="45.76" width="26.64" height="25"/>
      <text class="cls-10" transform="translate(678.75 63.52)"><tspan class="cls-29" x="0" y="0">T</tspan><tspan x="7.58" y="0">otal</tspan></text>
    </g>
  </g>
</svg>
    <div class="fuente-chart mt-5 mb-5">Fuentes: Produce, Oceana, Artisonal y Global Fishing Watch | El Foco</div>
  </div>
 </div>
</template>

<style>

  .container-graph {
    width: 100%;
    max-width: 920px;
    margin: 0 auto;
  }
 
  .container-graph h3 {
    font-family: "Fira Sans";
    width: 100%;
    max-width: 620px;
    margin: 35px auto;
    font-weight: 900;
  }
  
  .fuente-chart {
    font-size: 15px;
    text-align: right;
  }

  .carousel-title {
    font-size: 31px;
    color: #fff;
    font-family: "Fira Sans",sans-serif;
  }

  .carrusel-container-personajes {
    background-color: #f8f8f8;
    background-repeat: no-repeat;
    background-size: cover;
    padding: 15px 0;
    margin: 25px 0;
    width: 100%;
    overflow: hidden;
  }

  .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {
        fill: none;
      }

      .cls-2 {
        stroke-dasharray: 2 2 2 2;
      }

      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {
        stroke: #000;
      }

      .cls-2, .cls-3, .cls-5, .cls-6 {
        stroke-width: .5px;
      }

      .cls-7 {
        fill: #29ccc7;
      }

      .cls-8 {
        font-size: 13px;
      }

      .cls-8, .cls-9 {
        fill: #666;
      }

      .cls-8, .cls-9, .cls-10 {
        font-family: Roboto-Medium, Roboto;
      }

      .cls-8, .cls-9, .cls-10, .cls-11 {
        font-weight: 500;
      }

      .cls-3 {
        stroke-dasharray: 2 2 2 2 2 2;
      }

      .cls-12 {
        fill: #333;
        font-size: 10px;
      }

      .cls-12, .cls-13, .cls-14 {
        font-family: Roboto-Bold, Roboto;
        font-weight: 700;
      }

      .cls-15 {
        fill: #0080b2;
      }

      .cls-4 {
        stroke-width: .62px;
      }

      .cls-13, .cls-10 {
        font-size: 15px;
      }

      .cls-16 {
        letter-spacing: 0em;
      }

      .cls-17 {
        clip-path: url(#clippath-1);
      }

      .cls-18 {
        clip-path: url(#clippath-3);
      }

      .cls-19 {
        clip-path: url(#clippath-4);
      }

      .cls-20 {
        clip-path: url(#clippath-2);
      }

      .cls-21 {
        clip-path: url(#clippath-7);
      }

      .cls-22 {
        clip-path: url(#clippath-6);
      }

      .cls-23 {
        clip-path: url(#clippath-9);
      }

      .cls-24 {
        clip-path: url(#clippath-8);
      }

      .cls-25 {
        clip-path: url(#clippath-5);
      }

      .cls-26 {
        letter-spacing: 0em;
      }

      .cls-9 {
        font-size: 14px;
      }

      .cls-10 {
        fill: #1a1a1a;
      }

      .cls-27 {
        letter-spacing: 0em;
      }

      .cls-6 {
        stroke-dasharray: 2 2 2 2 2 2;
      }

      .cls-28 {
        fill: #10b6ff;
      }

      .cls-11 {
        font-family: FiraSans-Medium, 'Fira Sans';
        font-size: 7.24px;
        isolation: isolate;
      }

      .cls-14 {
        font-size: 18px;
      }

      .cls-29 {
        letter-spacing: -.1em;
      }

      .cls-30 {
        letter-spacing: -.06em;
      }

      .cls-31 {
        letter-spacing: -.01em;
      }

      .cls-32 {
        letter-spacing: -.01em;
      }

      .cls-33 {
        letter-spacing: -.01em;
      }

      .cls-34 {
        letter-spacing: -.03em;
      }

      .cls-35 {
        letter-spacing: 0em;
      }

      .cls-36 {
        letter-spacing: 0em;
      }

      .cls-37 {
        letter-spacing: -.01em;
      }

      .cls-38 {
        letter-spacing: 0em;
      }

      .cls-39 {
        letter-spacing: 0em;
      }

      .cls-40 {
        clip-path: url(#clippath);
      }

      .cls-41 {
        letter-spacing: .01em;
      }

      .cls-42 {
        letter-spacing: 0em;
      }

      .cls-43 {
        letter-spacing: 0em;
      }

      .cls-44 {
        letter-spacing: 0em;
      }

</style>

<script>

export default {
  name: 'Carousel'
};
</script>
